/* ============================================================
   RUB BUDDY — theme.js
   Scroll reveal · mobile menu · AJAX cart drawer · variant switch
   ============================================================ */
(function () {
  'use strict';

  var T = window.RB || { empty: 'Your cart is empty.', remove: 'Remove', busy: 'Adding…', add: 'Add to cart' };

  /* ---------- scroll reveal ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14 });
    reveals.forEach(function (e) { io.observe(e); });
  } else {
    reveals.forEach(function (e) { e.classList.add('in'); });
  }

  /* ---------- mobile menu (handled in header.liquid inline script) ---------- */

  /* ---------- money formatting (EUR) ---------- */
  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('CartOverlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.documentElement.style.overflow = '';
  }

  function updateCounts(count) {
    document.querySelectorAll('.cart-link .count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function renderCart(cart) {
    updateCounts(cart.item_count);
    if (!drawer) return;
    var body = drawer.querySelector('.drawer__items');
    var foot = drawer.querySelector('.drawer__foot');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="drawer__empty">' + T.empty + '</p>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';

    body.innerHTML = cart.items.map(function (it) {
      var variant = (it.variant_title && it.variant_title.indexOf('Default') < 0)
        ? '<small>' + it.variant_title + '</small>' : '';
      var img = it.image
        ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="64" height="64">'
        : '';
      return '<div class="drawer__item" data-key="' + it.key + '">' +
        img +
        '<div class="drawer__item-info">' +
        '<b>' + it.product_title + '</b>' + variant +
        '<div class="drawer__qty">' +
        '<button type="button" data-act="dec" aria-label="Minder">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-act="inc" aria-label="Meer">+</button>' +
        '<button type="button" class="drawer__remove" data-act="rm">' + T.remove + '</button>' +
        '</div></div>' +
        '<div class="drawer__price">' + money(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    var sub = drawer.querySelector('.drawer__subtotal');
    if (sub) sub.textContent = money(cart.total_price);

    var shipWrap = drawer.querySelector('.drawer__ship');
    if (shipWrap) {
      var qty = cart.item_count;
      var txt = shipWrap.querySelector('.drawer__ship-text');
      var bar = shipWrap.querySelector('.drawer__ship-bar span');
      if (qty >= 3) {
        if (txt) txt.innerHTML = T.discMax || '';
        if (bar) bar.style.width = '100%';
        shipWrap.classList.add('is-unlocked');
      } else if (qty === 2) {
        if (txt) txt.innerHTML = T.discTier2 || '';
        if (bar) bar.style.width = '66%';
        shipWrap.classList.remove('is-unlocked');
      } else {
        if (txt) txt.innerHTML = T.discTier1 || '';
        if (bar) bar.style.width = '33%';
        shipWrap.classList.remove('is-unlocked');
      }
    }
  }

  function fetchCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
      { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refresh(open) {
    return fetchCart().then(function (c) { renderCart(c); if (open) openDrawer(); return c; });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-cart-toggle')) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('.js-cart-close') || e.target === overlay) { closeDrawer(); return; }

    var qb = e.target.closest('.drawer__qty button');
    if (qb) {
      var item = qb.closest('.drawer__item');
      var key = item.getAttribute('data-key');
      var act = qb.getAttribute('data-act');
      var span = item.querySelector('.drawer__qty span');
      var q = parseInt(span.textContent, 10) || 0;
      if (act === 'inc') q++; else if (act === 'dec') q = Math.max(0, q - 1); else q = 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: q })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- AJAX add to cart ---------- */
  document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = T.busy; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (item) {
          try {
            if (window.RBtrack) window.RBtrack('AddToCart', {
              content_name: item.product_title,
              content_ids: [item.product_id],
              content_type: 'product',
              value: (item.final_line_price || item.price || 0) / 100,
              currency: (window.RB && RB.currency) || 'EUR',
              quantity: item.quantity
            });
          } catch (e) {}
          return refresh(true);
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = orig; } });
    });
  });

  /* ---------- variant switching ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = root.querySelector('[data-variant-id]');
    var priceNow = root.querySelector('.price .now');
    var priceWas = root.querySelector('.price .was');
    var btn = root.querySelector('[data-atc]');
    var selects = root.querySelectorAll('.product-option');

    function selected() {
      var chosen = [];
      selects.forEach(function (s) { chosen.push(s.value); });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    function update() {
      var v = selects.length ? selected() : variants[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = money(v.compare_at_price);
          priceWas.style.display = '';
        } else { priceWas.style.display = 'none'; }
      }
      if (btn) {
        btn.disabled = !v.available;
        var sp = btn.querySelector('span');
        if (sp) sp.textContent = v.available ? T.add : (T.sold || 'Sold out');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  /* ---------- pack tiers: quantity + live price (incl. subscription 20% off) ---------- */
  document.querySelectorAll('.packs').forEach(function (packs) {
    var form = packs.closest('form');
    if (!form) return;
    var qtyInput = form.querySelector('[data-qty-input]');
    var nowEl = document.querySelector('[data-price-now]');
    var perdayEl = document.querySelector('[data-price-perday]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var SUB = 0.8; /* 20% off when subscribed */

    function recompute() {
      var pack = packs.querySelector('input[name="pack"]:checked');
      if (!pack) return;
      if (qtyInput) qtyInput.value = pack.getAttribute('data-qty') || '1';
      var cents = parseInt(pack.getAttribute('data-cents'), 10);
      var days = parseInt(pack.getAttribute('data-days'), 10) || 9;
      var planEl = form.querySelector('input[name="selling_plan"]:checked');
      var sub = planEl && planEl.value;
      if (isNaN(cents)) {
        var t = pack.getAttribute('data-total'), pd = pack.getAttribute('data-perday');
        if (nowEl && t) nowEl.textContent = t;
        if (perdayEl && pd) perdayEl.textContent = pd;
        if (stickyPrice && t) stickyPrice.textContent = t;
        return;
      }
      var total = sub ? Math.round(cents * SUB) : cents;
      var perday = Math.round(total / days);
      if (nowEl) nowEl.textContent = money(total);
      if (perdayEl) perdayEl.textContent = money(perday);
      if (stickyPrice) stickyPrice.textContent = money(total);
    }

    packs.addEventListener('change', recompute);
    form.addEventListener('change', function (e) { if (e.target.name === 'selling_plan') recompute(); });
    recompute();
  });

  /* ---------- sticky add-to-cart bar (mobile) ---------- */
  (function () {
    var bar = document.getElementById('StickyAtc');
    var atc = document.querySelector('[data-atc]');
    if (!bar || !atc) return;
    var buy = bar.querySelector('[data-sticky-buy]');
    if (buy) buy.addEventListener('click', function () { atc.click(); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.hidden = en.isIntersecting; });
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(atc);
    }
  })();

  /* ---------- product gallery: click thumb -> swap image / play video ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    var holder = g.querySelector('[data-gallery-video-holder]');
    var thumbs = g.querySelectorAll('[data-gallery-thumb], [data-gallery-vid]');
    function activate(btn) { thumbs.forEach(function (x) { x.classList.remove('is-active'); }); btn.classList.add('is-active'); }
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (holder) { holder.hidden = true; holder.innerHTML = ''; }
        if (main) {
          main.hidden = false;
          if (full) { main.style.opacity = '0'; var im = new Image(); im.onload = function () { main.src = full; main.style.opacity = '1'; }; im.src = full; }
        }
        activate(t);
      });
    });
    g.querySelectorAll('[data-gallery-vid]').forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-gallery-vid');
        var tpl = g.querySelector('[data-gallery-tpl="' + i + '"]');
        if (holder && tpl) {
          holder.innerHTML = tpl.innerHTML;
          holder.hidden = false;
          if (main) main.hidden = true;
          var v = holder.querySelector('video'); if (v) { try { v.play(); } catch (e) {} }
          activate(t);
        }
      });
    });
  });

  /* ---------- notify form: scroll to confirmation ---------- */
  var ok = document.querySelector('.notify-success');
  if (ok) { ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
})();
